import { Component, EventEmitter, HostListener, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormValidationService } from 'src/app/services/form-validation.service';
import { AgentCreatePassword, BaseMemberSessionList, } from 'src/app/models/password';
import { AdminDirectSystemLocation } from 'src/app/constants/admin-direct-system';
import { UpdatePasswordCriteria } from 'src/app/models/auth';
import { AuthService } from 'src/app/services/auth.service';
import { SessionService } from 'src/app/services/storage/session.service';
import { LoginPayload } from '@app/models/member';

@Component({
    selector: 'mwp-password',
    templateUrl: './password.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PasswordComponent implements OnInit {
    @Input() public userId: number = 0;
    @Input() public noBorder: boolean;
    @Input() public isAgent: boolean;
    @Input() public agentLoginId: number;
    @Input() public baseMemberSessionList: BaseMemberSessionList;
    @Input() public displayHeader: boolean = true;
    @Input() public isDialogBox: boolean;

    @Output() public emitPassword: EventEmitter<AgentCreatePassword | LoginPayload> = new EventEmitter();
    @Output() public emitComplete: EventEmitter<any> = new EventEmitter();

    @HostListener('window:keydown.enter', ['$event']) onEnter(e: Event): void {
        if (e instanceof KeyboardEvent)
            e.preventDefault();

        if (this.passwordForm?.valid)
            this.submitPassword();
        e.preventDefault();
    }

    public passwordForm: FormGroup;

    constructor(
        private formBuilder: FormBuilder,
        private authService: AuthService,
        private sessionService: SessionService,
    ) {
    }

    ngOnInit(): void {
        this.passwordForm = this.formBuilder.group({
            newPassword: [null, [Validators.required, Validators.compose([FormValidationService.validPassword(), FormValidationService.validMatchingValue('confirmPassword', true)])]],
            confirmPassword: [null, [Validators.required, Validators.compose([FormValidationService.validMatchingValue('newPassword')])]],
        });
        if (this.isAgent)
            this.passwordForm.addControl('agentLocation', new FormControl(null, Validators.required,));
        if (this.isDialogBox)
            this.passwordForm.addControl('currentPassword', new FormControl(null, Validators.required,));
    }


    public submitPassword(): void {
        if (this.isDialogBox) {
            const l_UpdatePasswordCriteria: UpdatePasswordCriteria = new UpdatePasswordCriteria;
            l_UpdatePasswordCriteria.existingPassword = this.passwordForm.get('currentPassword').value;
            l_UpdatePasswordCriteria.newPassword = this.passwordForm.get('newPassword').value;
            l_UpdatePasswordCriteria.newPasswordConfirm = this.passwordForm.get('confirmPassword').value;
            if (this.sessionService.session.isMember) {
                this.authService.updateMemberPassword(l_UpdatePasswordCriteria).subscribe(() => {
                    this.emitComplete.emit();
                });
            } else {
                l_UpdatePasswordCriteria.agentID = this.sessionService.session.agent.agentID;
                this.authService.updateAgentPassword(l_UpdatePasswordCriteria).subscribe(() => {
                    this.emitComplete.emit();
                });
            }
        } else {
            if (!this.isAgent) {
                const l_LoginPayload: LoginPayload = new LoginPayload();
                l_LoginPayload.password = this.passwordForm.get('newPassword').value;

                if (this.baseMemberSessionList) {
                    l_LoginPayload.username = this.baseMemberSessionList.members[0].memberName;
                    l_LoginPayload.systemNumber = this.baseMemberSessionList.members[0].systemNumber.toString();
                }

                this.emitPassword.emit(l_LoginPayload);
            } else {
                const l_AgentCreatePassword: AgentCreatePassword = new AgentCreatePassword();
                l_AgentCreatePassword.newPassword = this.passwordForm.get('newPassword').value;
                l_AgentCreatePassword.newPasswordConfirm = this.passwordForm.get('confirmPassword').value;
                l_AgentCreatePassword.agentID = this.agentLoginId;
                l_AgentCreatePassword.adminDirectSystem = this.passwordForm.get('agentLocation').value;

                if (l_AgentCreatePassword.adminDirectSystem == AdminDirectSystemLocation.Laptop) {
                    l_AgentCreatePassword.agentCity = this.passwordForm.get('location').get('agentCity').value;
                    l_AgentCreatePassword.agentState = this.passwordForm.get('location').get('agentState').value;
                }
                this.emitPassword.emit(l_AgentCreatePassword);
            }
        }
    }
}